/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import { axiosInstance } from '../axiosInstance'

const getAllGetchkdUsers = param => {
    return axiosInstance.post(`/api/gcadmin/v1/user/getAll`, param).then(res => res.data)
}
// const createGetchkdUser = (app) => {
//     return GCAxiosInstance.post(`/api/gc/v1/user/register`,app).then(res => res.data)
// }
const createGetchkdUser = (app) => {
    return axiosInstance.post(`/api/gcadmin/v1/user/register`, app).then(res => res.data)
}
const editGetchkdUser = (app) => {
    return axiosInstance.post(`/api/gcadmin/v1/user/update`, app).then(res => res.data)
}
const getGetchkdUserHistory = (app) => {
    return axiosInstance.post(`/api/gcadmin/v1/user/get-history`, app).then(res => res.data)
}

export {
    getAllGetchkdUsers,
    createGetchkdUser,
    editGetchkdUser,
    getGetchkdUserHistory
}
